import { TagPresentationProps } from "@insite/mobius/Tag";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { ButtonIcon, ButtonWrapper } from "@waytek/MobiusOverrides/Button/Button";
import { clearBtnStyle } from "@waytek/Utilities/styleguide/btnIcon";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

export const tag: RecursivePartial<{
    defaultProps?: TagPresentationProps | undefined;
}> = {
    defaultProps: {
        mergeCss: true,
        css: css`
            ${ButtonWrapper} {
                ${clearBtnStyle}

                min-height: auto;

                &:not(:disabled):hover {
                    background: none;
                    color: ${getColor(colorStrings.commonGlobalWhite)};

                    ${ButtonIcon} {
                        color: ${getColor(colorStrings.commonGlobalWhite)};
                    }
                }
            }
        `,
    },
};
